import { render, staticRenderFns } from "./stepItem.vue?vue&type=template&id=b216059e&scoped=true&"
import script from "./stepItem.vue?vue&type=script&lang=js&"
export * from "./stepItem.vue?vue&type=script&lang=js&"
import style0 from "./stepItem.vue?vue&type=style&index=0&id=b216059e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b216059e",
  null
  
)

export default component.exports